import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"

import type { ISupportContentCategory } from "@front-shared/types/objects.types.ts"

import { SUPPORT_CONFIG } from "../../config/support.config"
import { UtilHelper } from "../../helpers/util.helper.tsx"
import type { ISupportState } from "../../types/state.types.ts"

const initialState: ISupportState = {
    selectedContentCategory: null,
}

const supportSlice = createSlice({
    name: "support",
    initialState,
    reducers: {
        supportReset: () => initialState,

        supportSetSelectedContentCategory: (
            state,
            action: PayloadAction<ISupportContentCategory | null>,
        ) => {
            // Modify url when some article is selected
            if (action.payload) {
                UtilHelper.addUrlQueryParam(
                    SUPPORT_CONFIG.supportArticleUrlQueryKey,
                    action.payload.urlSlug,
                )
            }

            state.selectedContentCategory = action.payload
        },
    },
})

export const { supportReset, supportSetSelectedContentCategory } =
    supportSlice.actions

export const supportReducer = supportSlice.reducer
